/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ShutdownStatus,
  ShutdownStatus$inboundSchema,
  ShutdownStatus$Outbound,
  ShutdownStatus$outboundSchema,
} from "./shutdownstatus.js";

/**
 * Websocket event type
 */
export const ShutdownBannerEventType = {
  AlarmActivation: "alarm_activation",
  Error: "error",
  Keepalive: "keepalive",
  Reading: "reading",
  Setting: "setting",
  ShutdownBanner: "shutdown_banner",
  Trends: "trends",
  UserActivity: "user_activity",
} as const;
/**
 * Websocket event type
 */
export type ShutdownBannerEventType = OpenEnum<typeof ShutdownBannerEventType>;

/**
 * Stream of shutdown banner
 */
export type ShutdownBannerEvent = {
  /**
   * The trace metadata, initialized by the trace stream interceptor
   */
  traceMetadata?: { [k: string]: string } | undefined;
  /**
   * Information about the shutdown
   */
  shutdownStatus?: ShutdownStatus | undefined;
  /**
   * Websocket event type
   */
  type?: ShutdownBannerEventType | undefined;
};

/** @internal */
export const ShutdownBannerEventType$inboundSchema: z.ZodType<
  ShutdownBannerEventType,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(ShutdownBannerEventType);
/** @internal */
export const ShutdownBannerEventType$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  ShutdownBannerEventType
> = openEnums.outboundSchema(ShutdownBannerEventType);

/** @internal */
export const ShutdownBannerEvent$inboundSchema: z.ZodType<
  ShutdownBannerEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  TraceMetadata: types.optional(z.record(types.string())),
  shutdown_status: types.optional(ShutdownStatus$inboundSchema),
  type: ShutdownBannerEventType$inboundSchema.default("shutdown_banner"),
}).transform((v) => {
  return remap$(v, {
    "TraceMetadata": "traceMetadata",
    "shutdown_status": "shutdownStatus",
  });
});
/** @internal */
export type ShutdownBannerEvent$Outbound = {
  TraceMetadata?: { [k: string]: string } | undefined;
  shutdown_status?: ShutdownStatus$Outbound | undefined;
  type: string;
};

/** @internal */
export const ShutdownBannerEvent$outboundSchema: z.ZodType<
  ShutdownBannerEvent$Outbound,
  z.ZodTypeDef,
  ShutdownBannerEvent
> = z.object({
  traceMetadata: z.record(z.string()).optional(),
  shutdownStatus: ShutdownStatus$outboundSchema.optional(),
  type: ShutdownBannerEventType$outboundSchema.default("shutdown_banner"),
}).transform((v) => {
  return remap$(v, {
    traceMetadata: "TraceMetadata",
    shutdownStatus: "shutdown_status",
  });
});

export function shutdownBannerEventToJSON(
  shutdownBannerEvent: ShutdownBannerEvent,
): string {
  return JSON.stringify(
    ShutdownBannerEvent$outboundSchema.parse(shutdownBannerEvent),
  );
}
export function shutdownBannerEventFromJSON(
  jsonString: string,
): SafeParseResult<ShutdownBannerEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ShutdownBannerEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ShutdownBannerEvent' from JSON`,
  );
}
